import { FC, useCallback } from 'react';
import { useTheme } from 'styled-components';

import { Environment } from '../../../constants/environments';
import { CountryImages, ImagesApp } from '../../../constants/images';
import { useI18nContext } from '../../../hooks/contexts/i18n.context';
import { useResaleEventContext } from '../../../hooks/contexts/resaleEvent.context';
import PillButtonColorTheme from '../../Buttons/PillButtonColorTheme';
import { SupportIcon } from '../../SvgCustom';
import DropDownMenu from '../AppBar/DropDownMenu';
import { LocaleSelect, SelectedLocale } from '../AppBar/LocaleSelect';
import { StyledBadgeLocale } from '../AppBar/LocaleSelect/styles.localeSelect';
import * as Style from './styles';

export const ResaleListingAppBar: FC = () => {
  const { translate, currentLocale } = useI18nContext();
  const { event } = useResaleEventContext();
  const theme = useTheme();

  const locale = currentLocale.locale.replace('-', '_').toLowerCase();

  const handleSupportClick = useCallback(() => {
    window.open(Environment.SUPPORT_LINK, '_blank');
  }, []);
  const eventAddress = event?.place
    ? [event.place.name, event.place.city].filter(Boolean).join(' | ')
    : '';

  return (
    <>
      <Style.Container id="resale-listing-appbar-container" $hasEventSection={!!event}>
        <Style.BreadcrumbSection id="resale-listing-breadcrumb-section">
          <Style.BreadcrumbActive id="resale-listing-breadcrumb-active">
            {translate(['RESALE', 'BREADCRUMB'])}
          </Style.BreadcrumbActive>
        </Style.BreadcrumbSection>

        <Style.ContainerOptions id="resale-listing-container-options">
          <PillButtonColorTheme
            onClick={handleSupportClick}
            id="resale-listing-support-button"
          >
            <img src={SupportIcon({ colorTheme : theme.colors.accent.primary })} alt="support" />
            {translate(['BUTTONS', 'SUPPORT'])}
          </PillButtonColorTheme>
          <Style.LocaleSelector id="locale-selector-container">
            <StyledBadgeLocale
              src={ImagesApp.countries[locale as keyof CountryImages]}
              alt="locale flag"
              id="locale-flag"
            />
            <DropDownMenu
              prefixDropDown={<SelectedLocale />}
              contentDropDown={<LocaleSelect />}
            />
          </Style.LocaleSelector>
        </Style.ContainerOptions>
      </Style.Container>

      {event && (
        <Style.EventSection id="resale-listing-event-section">
          {event.poster?.medium && (
            <Style.CardImage>
              <Style.PosterImage src={event.poster.medium} alt={event.title} />
            </Style.CardImage>
          )}
          <Style.EventDetails>
            <Style.EventTitle>{event.title}</Style.EventTitle>
            {eventAddress && (
              <Style.Info>
                <Style.Icon src={ImagesApp.svg.placeIcon} alt="location" />
                <Style.EventLocation>{eventAddress}</Style.EventLocation>
              </Style.Info>
            )}
          </Style.EventDetails>
        </Style.EventSection>
      )}
    </>
  );
};
